import {
  normalizeCombatActionRequest
} from './CombatActionRequestNormalizer';

export const getCombatActionRoute = (requestLike, options = {}) => (
  normalizeCombatActionRequest(requestLike, options).route
);

export const shouldDelegateCombatActionToBattleRoom = (requestLike, options = {}) => {
  const request = normalizeCombatActionRequest(requestLike, options);

  if (request.hasAreaOfEffect) return true;
  if (request.requiresBattleRoomTargeting) return true;
  return false;
};

export const executeCombatActionRequest = async (requestLike, handlers = {}, options = {}) => {
  const request = normalizeCombatActionRequest(requestLike, options);

  switch (request.route) {
    case 'spell':
      return handlers.onSpell ? handlers.onSpell(request) : false;
    case 'attack':
      return handlers.onAttack ? handlers.onAttack(request) : false;
    case 'ability':
      return handlers.onAbility ? handlers.onAbility(request) : false;
    default:
      return handlers.onStandard ? handlers.onStandard(request) : false;
  }
};

const CombatExecutionRouter = {
  getCombatActionRoute,
  shouldDelegateCombatActionToBattleRoom,
  executeCombatActionRequest
};

export default CombatExecutionRouter;
